const defaultState = {
    username: 'Onbekend',
    loggedIn: false
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case 'SET_USER_LOGGED_IN': {
            return {
                ...state,
                username: action.payload.username,
                loggedIn: action.payload.loggedIn
            };
        }
        default: {
            return state;
        }
    }
}
